import request from '../../../request/request';

const getUserDetails = ({ userName }) => {
  return request({
    url: `/webapi/user/${userName}/details`
  });
};

const getUserGroupInfo = ({ userName }) => {
  return request({
    url: `/webapi/user/${userName}/groups`
  });
};

const getUserBasicInfo = ({ userName }) => {
  return request({
    url: `/webapi/user/${userName}/basic-info`
  });
};

const editUserBasicInfo = ({
  name,
  displayName,
  telephone,
  email,
  company,
  contractNumber,
  projectName
}) => {
  return request({
    url: `/webapi/user/${name}/update-details`,
    method: 'POST',
    data: {
      name,
      displayName,
      telephone,
      email,
      company,
      contractNumber,
      projectName
    }
  });
};

const assignGroups = data => {
  const { userName, groups } = data;
  return request({
    url: `/webapi/user/${userName}/assign-groups`,
    method: 'post',
    data: { groups }
  });
};

export {
  getUserDetails,
  getUserBasicInfo,
  editUserBasicInfo,
  assignGroups,
  getUserGroupInfo
};
